// extracted by mini-css-extract-plugin
var _1 = "#68914d";
var _2 = "#9cc681";
var _3 = "#8ab46f";
var _4 = "avatar___R9Lkn";
var _5 = "avatar--color-0___toTwd";
var _6 = "avatar--color-1___gxlpB";
var _7 = "avatar--color-2___H60R3";
var _8 = "avatar--color-3___O6ftA";
var _9 = "avatar--color-4___KhM9o";
var _a = "avatar--color-5___LmiRs";
var _b = "avatar--color-6___FjSpy";
var _c = "avatar--color-7___m68pX";
var _d = "avatar--color-8___YSpaG";
var _e = "avatar--color-9___pNdh7";
var _f = "avatar--fallback___Yjzc3";
var _10 = "avatar--large___zGPRJ";
var _11 = "8px";
var _12 = "6px";
var _13 = "8px";
var _14 = "0 1px 1px 0 rgba(0,0,0,.02) inset";
var _15 = "0 8px 8px -4px rgba(0,0,0,.03),0 16px 24px -4px rgba(0,0,0,.08)";
var _16 = "10px";
var _17 = "#e8e8e8";
var _18 = "16px 24px";
var _19 = "#38aa73";
var _1a = "#956c22";
var _1b = "#2988bd";
var _1c = "#eee";
var _1d = "#c4842d";
var _1e = "#b8567c";
var _1f = "#8b6e4e";
var _20 = "#5889c2";
var _21 = "#4e8a8a";
var _22 = "#6a8a3e";
var _23 = "#7b5ea7";
var _24 = "#4a6fa5";
var _25 = "#3a8a6e";
var _26 = "#c25b4e";
var _27 = "#fafbfc";
var _28 = "#1e3050";
var _29 = "#293d62";
var _2a = "#fafbfc";
var _2b = "rgba(0,0,0,.12)";
var _2c = "#d9d9d9";
var _2d = "rgba(5,5,5,.1)";
var _2e = "#eaf2fc";
var _2f = "rgba(0,0,0,.65)";
var _30 = "#ebebeb";
var _31 = "#068467";
var _32 = "rgba(6,132,103,.1)";
var _33 = "#dc4949";
var _34 = "rgba(220,73,73,.1)";
var _35 = "#787c81";
var _36 = "#d6d9dc";
var _37 = "#f3f5f7";
var _38 = "#73c9b2";
var _39 = "linear-gradient(180deg, #73C9B2 0%, #B8E7DA 100%)";
var _3a = "#b8e7da";
var _3b = "#5357f8";
var _3c = "rgb(14.3921787709,19.9877094972,245.2078212291)";
var _3d = "rgb(249.6189944134,249.7441340782,254.7810055866)";
var _3e = "#f7f8f9";
var _3f = "#edeeef";
var _40 = "#7b8996";
var _41 = "#ededed";
var _42 = "#f4f5f7";
var _43 = "#fbfbfc";
var _44 = "rgba(0,0,0,.75)";
var _45 = "rgba(171.2567039106,172.4612273574,220.9432960894,.95)";
var _46 = "rgba(0,0,0,.3)";
var _47 = "rgba(0,0,0,.5)";
var _48 = "rgba(0,0,0,.4)";
var _49 = "rgba(0,0,0,.95)";
var _4a = "rgba(0,0,0,.65)";
var _4b = "rgba(0,0,0,.85)";
var _4c = "20px";
var _4d = "#f41e28";
var _4e = "1063px";
var _4f = "email___JYcjG";
var _50 = "rgba(227,89,86,.2)";
var _51 = "#e35956";
var _52 = "16px 24px";
var _53 = "28px";
var _54 = "32px";
var _55 = "18px";
var _56 = "14px";
var _57 = "14px";
var _58 = "15px";
var _59 = "12.6px";
var _5a = "11px";
var _5b = "20px";
var _5c = "28px";
var _5d = "700";
var _5e = "200";
var _5f = "300";
var _60 = "500";
var _61 = "400";
var _62 = "600";
var _63 = "hsla(0,0%,100%,.2)";
var _64 = "#ccc";
var _65 = "49px";
var _66 = "5px";
var _67 = "#5357f8";
var _68 = "rgba(0,0,0,.4)";
var _69 = "#fafafa";
var _6a = "hsla(0,0%,100%,.9)";
var _6b = "15px";
var _6c = "20px";
var _6d = "24px";
var _6e = "hsla(0,0%,100%,.6)";
var _6f = "#7e7eff";
var _70 = "hsla(0,0%,100%,.7)";
var _71 = "hsla(0,0%,100%,.3)";
var _72 = "hsla(0,0%,100%,.575)";
var _73 = "60px";
var _74 = "208px";
var _75 = "rgba(82,196,26,.2)";
var _76 = "#52c41a";
var _77 = "12px";
var _78 = "20px";
var _79 = "user-badge___KOaAz";
var _7a = "rgba(250,173,20,.2)";
var _7b = "#faad14";
var _7c = "#fff";
var _7d = "hsla(0,0%,100%,.2)";
export { _1 as "actionButtonColorDark", _2 as "actionButtonColorLight", _3 as "actionButtonColorMedium", _4 as "avatar", _5 as "avatar--color-0", _6 as "avatar--color-1", _7 as "avatar--color-2", _8 as "avatar--color-3", _9 as "avatar--color-4", _a as "avatar--color-5", _b as "avatar--color-6", _c as "avatar--color-7", _d as "avatar--color-8", _e as "avatar--color-9", _f as "avatar--fallback", _10 as "avatar--large", _11 as "borderRadiusCard", _12 as "borderRadiusMain", _13 as "borderRadiusSurface", _14 as "boxShadowInnerXs", _15 as "boxShadowXl", _16 as "btnRightMargin", _17 as "cardBorderColor", _18 as "cardPadding", _19 as "changeSetCompletedColor", _1a as "changeSetManuallyChangesProposed", _1b as "changeSetScheduledChangesProposed", _1c as "chipBackground", _1d as "colorAccentAmber", _1e as "colorAccentBerry", _1f as "colorAccentBrown", _20 as "colorAccentCornflower", _21 as "colorAccentCyan", _22 as "colorAccentOlive", _23 as "colorAccentPurple", _24 as "colorAccentSteelBlue", _25 as "colorAccentTeal", _26 as "colorAccentTerracotta", _27 as "colorBackgroundMain", _28 as "colorBackgroundSidebar", _29 as "colorBackgroundSidebarHover", _2a as "colorBackgroundTabs", _2b as "colorBorderContainer", _2c as "colorBorderMain", _2d as "colorBorderSecondary", _2e as "colorDeltaCyanBlueBg", _2f as "colorDeltaGray", _30 as "colorDeltaGrayBg", _31 as "colorDeltaGreen", _32 as "colorDeltaGreenBg", _33 as "colorDeltaRed", _34 as "colorDeltaRedBg", _35 as "colorDetailsFieldText", _36 as "colorDetailsIcon", _37 as "colorDetailsTagBg", _38 as "colorMint", _39 as "colorMintGradient", _3a as "colorMintLight", _3b as "colorPrimary", _3c as "colorPrimaryHover", _3d as "colorPrimaryLightened", _3e as "colorTableHeadBg", _3f as "colorTableHeadBgHover", _40 as "colorTableHeadSubtitle", _41 as "colorTableRowBorder", _42 as "colorTableTextBg", _43 as "colorTableTotalRowBg", _44 as "colorTextBase", _45 as "colorTextDisabled", _46 as "colorTextExtraLight", _47 as "colorTextLight", _48 as "colorTextLighter", _49 as "colorTextMainHeading", _4a as "colorTextMuted", _4b as "colorTextPrimary", _4c as "contentHorizPadding", _4d as "dangerColor", _4e as "dashboardPdfContentWidth", _4f as "email", _50 as "errorBackcolor", _51 as "errorColor", _52 as "filterPanelPadding", _53 as "filtersDefaultHeight", _54 as "filtersTallHeight", _55 as "fontSizeLarge", _56 as "fontSizeMain", _57 as "fontSizeMedium", _58 as "fontSizePlus", _59 as "fontSizeSmaller", _5a as "fontSizeSmallest", _5b as "fontSizeXLarge", _5c as "fontSizeXxLarge", _5d as "fontWeightBold", _5e as "fontWeightExtraLight", _5f as "fontWeightLight", _60 as "fontWeightMediumBold", _61 as "fontWeightNormal", _62 as "fontWeightSemiBold", _63 as "ghostWhite", _64 as "grayBackgroundColor", _65 as "headerHeight", _66 as "iconHorizontalMargin", _67 as "linkColor", _68 as "linkColorMuted", _69 as "popoverHeaderColor", _6a as "popoverMaskColor", _6b as "rowPadding", _6c as "ruleInnerGutters", _6d as "ruleSideGutters", _6e as "sideMenuIconColor", _6f as "sideMenuIconSelectedColor", _70 as "sideMenuItemColor", _71 as "sideMenuScrollbarThumbColor", _72 as "sideMenuSubmenuItemColor", _73 as "sidebarCollapsedWidth", _74 as "sidebarWidth", _75 as "successBackcolor", _76 as "successColor", _77 as "tableHeaderVerticalPadding", _78 as "tableHorizPadding", _79 as "user-badge", _7a as "warningBackcolor", _7b as "warningColor", _7c as "whiteColor", _7d as "whiteDividerColor" }
